import { createSelector } from 'reselect';

// Config
import {
  getAppShowExpressPayments,
  getIsApplePayExpressEnabled,
  getIsPayPalPayExpressEnabled,
} from '@redux/reducers/app/appSelector';
import {
  getDeliveriesSelector,
  getShowAmendQuantityNotificationSelector,
} from '@redux/reducers/delivery/deliverySelector';
import {
  getPaymentPageCompleteSelector,
  getBasketTotalRawSelector,
  getSubmitOrderFailedSelector,
} from '@redux/reducers/order-form/orderFormSelector';
import {
  getApplePayCompatibilityChecksComplete,
  getGetPayPalClientTokenCallActiveSelector,
  getInvalidPayPalBillingAddressSelector,
  getInvalidPayPalShippingAddressSelector,
  getPayPalPayExpressCompatibilityChecksCompleteSelector,
  getPayPalServiceUnavailableSelector,
  getAppShowExpressPaymentsFailedMessage,
  getExpressCountryCodeErrorSelector,
} from '@redux/reducers/payment/paymentSelector';

const expressPaymentsState = createSelector(
  [
    getApplePayCompatibilityChecksComplete,
    getPayPalPayExpressCompatibilityChecksCompleteSelector,
    getAppShowExpressPayments,
    getDeliveriesSelector,
    getPaymentPageCompleteSelector,
    getAppShowExpressPaymentsFailedMessage,
    getBasketTotalRawSelector,
    getSubmitOrderFailedSelector,
    getShowAmendQuantityNotificationSelector,
    getInvalidPayPalBillingAddressSelector,
    getInvalidPayPalShippingAddressSelector,
    getGetPayPalClientTokenCallActiveSelector,
    getPayPalServiceUnavailableSelector,
    getIsApplePayExpressEnabled,
    getIsPayPalPayExpressEnabled,
    getExpressCountryCodeErrorSelector,
  ],
  (
    applePayCompatibilityChecksComplete,
    payPalPayExpressCompatibilityChecksComplete,
    showExpressPayments,
    deliveries,
    getPaymentPageComplete,
    showExpressPaymentsFailedMessage,
    basketTotalRaw,
    submitOrderFailed,
    showAmendQuantityNotification,
    invalidPayPalBillingAddress,
    invalidPayPalShippingAddress,
    getPayPalClientTokenCallActive,
    payPalServiceUnavailable,
    isApplePayExpressEnabled,
    isPayPalPayExpressEnabled,
    expressCountryCodeError,
  ) => ({
    isApplePayExpressEnabled,
    isPayPalPayExpressEnabled,
    showExpressPayments,
    deliveries,
    getPaymentPageComplete,
    showExpressPaymentsFailedMessage,
    basketTotalRaw,
    submitOrderFailed,
    showAmendQuantityNotification,
    invalidPayPalBillingAddress,
    invalidPayPalShippingAddress,
    getPayPalClientTokenCallActive,
    payPalServiceUnavailable,
    applePayCompatibilityChecksComplete,
    payPalPayExpressCompatibilityChecksComplete,
    expressCountryCodeError,
  }),
);

export default expressPaymentsState;
